var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#1E1E1E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 4.5,
    stroke: "white",
    strokeOpacity: 0.57
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0371 14L27.8881 16.851L25.0371 19.702",
    stroke: "#D9D9D9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.186 16.8511H27.8881",
    stroke: "#D9D9D9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1754 25.347V27.4853C27.1762 27.6838 27.1355 27.8803 27.056 28.0622C26.9765 28.244 26.8598 28.4073 26.7136 28.5415C26.5673 28.6757 26.3946 28.7779 26.2065 28.8415C26.0185 28.9051 25.8193 28.9287 25.6216 28.9108C23.4283 28.6725 21.3215 27.923 19.4705 26.7226C17.7483 25.6283 16.2883 24.1683 15.1939 22.4461C13.9894 20.5867 13.2397 18.4696 13.0058 16.2665C12.988 16.0694 13.0114 15.8708 13.0746 15.6832C13.1377 15.4957 13.2393 15.3233 13.3727 15.1772C13.5061 15.031 13.6685 14.9142 13.8495 14.8343C14.0306 14.7543 14.2263 14.7129 14.4242 14.7127H16.5624C16.9083 14.7093 17.2437 14.8318 17.506 15.0574C17.7682 15.2829 17.9395 15.5961 17.9879 15.9387C18.0782 16.6229 18.2456 17.2948 18.4869 17.9415C18.5828 18.1966 18.6035 18.4739 18.5467 18.7404C18.4898 19.007 18.3578 19.2516 18.1661 19.4454L17.2609 20.3506C18.2756 22.135 19.7531 23.6125 21.5375 24.6271L22.4427 23.7219C22.6365 23.5303 22.8811 23.3982 23.1477 23.3414C23.4142 23.2846 23.6915 23.3053 23.9466 23.4012C24.5932 23.6425 25.2651 23.8099 25.9494 23.9001C26.2957 23.949 26.6119 24.1234 26.8379 24.3901C27.0639 24.6569 27.184 24.9975 27.1754 25.347Z",
    stroke: "#D9D9D9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall1);
export default __webpack_public_path__ + "static/media/call1.c0e9fe2f61093f63f30ed2b95f0ec579.svg";
export { ForwardRef as ReactComponent };